import { Hidden } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import moment from 'moment-jalaali'
import React from 'react'

import { getTimeView } from '../../../../helpers/date'
import { getTranslate } from '../../../../localization'
import VerticalSeparator from '../separator/VerticalSeparator'
import { DatePickerBoxProps } from '../types/DateRangePicker.types'
import useStyles from './styles/datePickerBox.style'

const DatePickerBox: React.FC<DatePickerBoxProps> = (props) => {
  const { className, noBorder, title, selectedDate, type } = props
  const classes = useStyles()
  const { dayView, monthView, yearView } = getTimeView(type)
  const rootClasses = className
    ? [classes.root, className].join(' ')
    : classes.root
  let day = ''
  let monthName = ''
  let year = ''
  if (selectedDate) {
    day = moment(selectedDate, getTimeView(type).basicView).format(dayView)
    monthName = moment(selectedDate, getTimeView(type).basicView).format(
      monthView
    )
    year = moment(selectedDate, getTimeView(type).basicView).format(yearView)
  }

  return (
    <Grid className={classes.rootGrid}>
      <Grid container direction="column" className={rootClasses}>
        <Grid item className={classes.title}>
          <Typography variant="h6">{getTranslate(title)}</Typography>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid className={classes.dateDayBox}>
              <Typography variant="h2">{day}</Typography>
            </Grid>
            <Grid item className={classes.monthAndYearGrid}>
              <Typography variant="h5">{`${year} ${monthName.slice(
                0,
                5
              )}`}</Typography>
            </Grid>
            <Hidden xsDown>
              <Grid item className={classes.chevronsGrid}></Grid>
            </Hidden>
          </Grid>
        </Grid>
      </Grid>
      {!noBorder && <VerticalSeparator />}
    </Grid>
  )
}

export default DatePickerBox
